import { NavLink, useParams,  } from "react-router-dom";
import Layout from "../../components/Layout/Layout";
import { useEffect, useState } from "react";
import DraggAbleComponentEdit from "./DraggAbleComponentEdit";

function EditLiveTable(){
	const [componentList, setComponentList] = useState([]); useState([]);
	const [componentDetails, setComponentDetails] = useState({name:""});
	const [edit, setEdit] = useState({})
	const { id }  = useParams(); 

	function addTable(){
		setComponentList([...componentList, 
			{
				name:componentDetails.name, 
				id:`table${Date.now()}`,
				style:{ left: "350px", top: "350px", backgroundColor:"#83C27E" },
				isMerged:false,
				mergedComponent:[],
				mergedName:""
			}
		])
		setComponentDetails({name:""})
	}

	function removeTable(id) {
		if (confirm("Are you sure you want to delete this table?")) {
			const updatedList = componentList.filter(component => component.id !== id);
			setComponentList(updatedList);
			localStorage.setItem("componentList", JSON.stringify(updatedList));
		}
	}

	function setTableStyle(id, css){
		componentList.map((data)=>{
			if(data.id == id){
				data.style = {...data.style, ...css}
			}
		})
		localStorage.setItem("componentList", JSON.stringify(componentList))
	}

	function setDetails(e){
		setComponentDetails({...componentDetails, [e.target.name]:e.target.value })
	}

	useEffect(()=>{
		const data = localStorage.getItem("componentList")
		if(data){
			setComponentList(JSON.parse(data))
		}
	},[])

	useEffect(()=>{
		setComponentDetails({...componentDetails, name:edit?.name })
	}, [edit])

	console.log(edit)

	return(
		<div className=" w-screen h-screen bg-color1">
			<Layout>
				<div className=" w-full mt-1 h-full flex">
					<div className=" w-[76%] h-full bg-color1 flex flex-col ">
							<div className=" w-full h-[42px] border-color3 flex ">
								<div className=" w-[80%] relative ">
									<NavLink to={"/live-table/"+id} className={(e)=> ` w-[100px] absolute bg-color1 text-color4 text-center p-1 border-color3 border-x border-t ${e.isActive? " h-[42px]":"h-[40px]"} rounded-sm `}>Live Table</NavLink>
									<NavLink to={"/edit-live-table/"+id} className={(e)=> ` w-[100px] h-[40px] absolute left-[120px] bg-color1 text-color4 text-center p-1 border-color3 border-x border-t ${e.isActive? " h-[42px]":"h-[40px]"} rounded-sm `}>Edit Table</NavLink>
									<NavLink to={"/merge-live-table/"+id} className={(e)=> ` w-[100px] h-[40px] absolute left-[240px] bg-color1 text-color4 text-center p-1 border-color3 border-x border-t ${e.isActive? " h-[42px]":"h-[40px]"} rounded-sm `}>Merge Table</NavLink>
									<NavLink to={"/separate-live-table/"+id} className={(e)=> ` w-[120px] h-[40px] absolute left-[360px] bg-color1 text-color4 text-center p-1 border-color3 border-x border-t ${e.isActive? " h-[42px]":"h-[40px]"} rounded-sm `}>Separate Table</NavLink>
								</div>
								<div className=" w-[20%] flex items-center">
									<h1 className=" text-xl text-color4 uppercase font-semibold">Room {id}</h1>
								</div>
							</div>

							<div className=" w-full h-full border-t border-color3 ">
								{
									componentList.map((data, index)=>{
										return(
											<DraggAbleComponentEdit key={index} data={data} setTableStyle={setTableStyle} setEdit={setEdit} removeTable={removeTable} />
										)
									})
								}
							</div>
					</div>
					{
						edit?.id?
						<div className=" w-[24%] h-full bg-color2 p-2 ">
							<h2 className=" pb-2 text-center uppercase font-semibold text-color6 border-b border-color6">Edit Table {edit?.name}</h2>

							<label htmlFor="name" className=" mt-2 block text-color5">Table Name</label>
							<input onChange={setDetails} type="text" name="name" placeholder="T1" value={componentDetails?.name} className=" w-full py-1 px-1 bg-color3 text-color4 border-none outline-none" />

							<div className=" flex gap-4">
								<button className=" w-full mt-4 py-1 bg-color7 rounded-md text-center">Save</button>
								<button onClick={()=> setEdit({})} className=" w-full mt-4 py-1 bg-color8 rounded-md text-center">Cancel</button>
							</div>
						</div>:
						<div className=" w-[24%] h-full bg-color2 p-2 ">
							<h2 className=" pb-2 text-center uppercase font-semibold text-color6 border-b border-color6">Add Table</h2>

							<label htmlFor="name" className=" mt-2 block text-color5">Table Name</label>
							<input onChange={setDetails} type="text" name="name" placeholder="T1" value={componentDetails?.name} className=" w-full py-1 px-1 bg-color3 text-color4 border-none outline-none" />

							<button onClick={addTable} className=" w-full mt-4 py-1 bg-color7 rounded-md text-center">Add</button>
						</div>
					}
				</div>
			</Layout>
		</div>
	)
}

export default EditLiveTable;

